import React from "react";
import { StandadCard } from "../../../../components/Cards";
import { useAuth } from "../../../../contexts/AuthProvider/AuthProvider";
import { useMessagesPopup } from "../../../../contexts/MessagesPopupProvider/MessagesPopupProvider";
import { api } from "../../../../api/api";
import { Typography, Grid, CircularProgress, Box } from "@mui/material";
import { formatDateWithTime } from "../../../../helpers";
import { CustomTypography } from "../../../../components/formsComponents";

interface IService {
  user_id: number;
  user_subcription_id: number;
  user_subscription_dim_id: number;
  membership_code: string;
  contact_number: string;
  vehicle_number: string;
  maker_name: string;
  model_name: string;
  registration_year: number;
  state: string;
  city: string;
  area: string;
  address: string;
  gstin_no: string;
  status: string;
  comment: string;
  insert_dt: string;
  user_profile_id: number;
  user_name: string;
  email_id: string;
  father_name: string;
  gender: string;
  mobile_number: string;
  pin: string;
  services_id: number;
  total_services: number;
  used_services: number;
  remain_services: number;
  membership_start_date: string;
  membership_expiry_date: string;
  package_id: number;
  branch_office: string;
}

export const ServiceDetails = ({ membershipId }: { membershipId?: string }) => {
  const [loading, setLoading] = React.useState(false);
  const { showTopErrorSnackbar } = useMessagesPopup();
  const [serviceDetails, setServiceDetails] = React.useState<IService[] | null>(
    null
  );
  console.log(serviceDetails?.[0].membership_code);
  const auth = useAuth();

  const fetchServiceDetails = async () => {
    if (auth.user.isLogin && auth.user.tokens && membershipId) {
      try {
        setLoading(true);
        const res = await api.get(
          `get-details-by-membershipcode?membership_code=${membershipId}`,
          {
            headers: {
              "auth-Token": auth.user.tokens.access,
            },
          }
        );
        setServiceDetails(res.data);
      } catch (err) {
        showTopErrorSnackbar("Something went wrong!!");
      } finally {
        setLoading(false);
      }
    }
  };

  React.useEffect(() => {
    fetchServiceDetails();
  }, [membershipId]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!serviceDetails) {
    return <Typography>No service details available.</Typography>;
  }

  console.log(serviceDetails[0]);

  console.log(serviceDetails[0].membership_code);

  return (
    <div>
      <StandadCard
        heading="Select Membership Code Service Details"
        sx={{ mt: 4 }}
      >
        <Grid container spacing={12}>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Membership Code:</strong>
              {serviceDetails[0].membership_code}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>User Name:</strong> {serviceDetails[0].user_name}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Contact Number:</strong>{" "}
              {serviceDetails[0].contact_number}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Email:</strong> {serviceDetails[0].email_id}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Total Services:</strong>{" "}
              {serviceDetails[0].total_services}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Used Services:</strong> {serviceDetails[0].used_services}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Remaining Services:</strong>{" "}
              {serviceDetails[0].remain_services}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Membership Start Date:</strong>{" "}
              {formatDateWithTime(serviceDetails[0].membership_start_date)}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Membership Expiry Date:</strong>{" "}
              {formatDateWithTime(serviceDetails[0].membership_expiry_date)}
            </CustomTypography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Vehicle Number:</strong>{" "}
              {serviceDetails[0].vehicle_number}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Maker Name:</strong> {serviceDetails[0].maker_name}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Model Name:</strong> {serviceDetails[0].model_name}
            </CustomTypography>

            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Gender:</strong> {serviceDetails[0].gender}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>PIN:</strong> {serviceDetails[0].pin}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Registration Year:</strong>{" "}
              {serviceDetails[0].registration_year}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>Address:</strong> {serviceDetails[0].address}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>State:</strong> {serviceDetails[0].state}
            </CustomTypography>
            <CustomTypography
              sx={{ fontSize: "18px", display: "flex", gap: "5px" }}
            >
              <strong>City:</strong> {serviceDetails[0].city}
            </CustomTypography>
          </Grid>
        </Grid>
      </StandadCard>
    </div>
  );
};
